import { render } from "./ScormPlayer.vue?vue&type=template&id=a9e75cc4"
import script from "./ScormPlayer.vue?vue&type=script&lang=js"
export * from "./ScormPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__